import React from "react";
import styles from "./index.css";

const IconNotification = () => (
  <span className={styles.notification} aria-label="You have one notification">
    1
  </span>
);

export default IconNotification;
